(() => {
  if (window.__sqShopByMomentMenuV1) return;
  window.__sqShopByMomentMenuV1 = true;

  const ITEMS = [
    { title: 'Event Ready', url: '/collections/signature-dresses', note: 'Occasion dressing' },
    { title: 'Everyday Confidence', url: '/collections/most-loved-styles', note: 'Polished daily style' },
    { title: 'Vacation Mode', url: '/collections/coastal-swimwear', note: 'Getaway wardrobe' },
    { title: 'Desk to Dinner', url: '/collections/coordinated-sets', note: 'Work-to-evening looks' },
    { title: 'Make a Statement', url: '/collections/statement-outerwear', note: 'Impact pieces' }
  ];

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function directDesktopTrigger(item) {
    return item?.querySelector(
      ':scope > a.menu-list__link, :scope > button.menu-list__link, :scope > summary.menu-list__link'
    );
  }

  function desktopTopItems(header) {
    return Array.from(header.querySelectorAll('header-menu .menu-list__list-item')).filter(
      (item) => item.parentElement?.closest('.menu-list__list-item') == null
    );
  }

  function findDesktopShop(header) {
    const items = desktopTopItems(header);
    const named = items.find((item) => {
      const title = normalize(directDesktopTrigger(item)?.textContent);
      return title === 'shop' || title === 'shop home' || title === 'shop every style';
    });
    if (named) return named;

    return items.find((item) => {
      const trigger = directDesktopTrigger(item);
      if (!(trigger instanceof HTMLAnchorElement)) return false;
      try {
        const path = new URL(trigger.href, window.location.origin).pathname.replace(/\/$/, '');
        return path === '/collections' || path === '/collections/shop-every-style';
      } catch (_) {
        return false;
      }
    }) || null;
  }

  function desktopMarkup() {
    return ITEMS.map((item) => `
      <li>
        <a class="mega-menu__link sq-shop-moment-menu__link" href="${item.url}">
          <span class="sq-shop-moment-menu__copy">
            <strong>${item.title}</strong>
            <small>${item.note}</small>
          </span>
          <span class="sq-shop-moment-menu__arrow" aria-hidden="true">↗</span>
        </a>
      </li>
    `).join('');
  }

  function buildDesktop(header) {
    const shopItem = findDesktopShop(header);
    const submenu = shopItem?.querySelector(':scope > .menu-list__submenu');
    const list = submenu?.querySelector('.mega-menu__list');
    if (!list || list.querySelector('[data-sq-shop-moment-menu]')) return false;

    const column = document.createElement('li');
    column.className = 'mega-menu__column mega-menu__column--span-2 sq-shop-moment-menu__desktop';
    column.dataset.sqShopMomentMenu = '';
    column.innerHTML = `
      <div class="sq-shop-moment-menu__desktop-inner">
        <a class="mega-menu__link mega-menu__link--parent sq-shop-moment-menu__heading" href="/collections/signature-dresses">
          Shop by Moment
        </a>
        <p class="sq-shop-moment-menu__intro">Start with where you are going and how you want to feel.</p>
        <ul class="list-unstyled sq-shop-moment-menu__grid">
          ${desktopMarkup()}
        </ul>
      </div>
    `;
    list.prepend(column);
    return true;
  }

  function rootMobileList(header) {
    const drawer = header.querySelector('header-drawer');
    if (!drawer) return null;
    return Array.from(drawer.querySelectorAll('ul.menu-drawer__menu.has-submenu')).find(
      (list) => list.closest('.menu-drawer__submenu') == null
    ) || null;
  }

  function directMobileLabel(item) {
    const trigger = item?.querySelector(':scope > a, :scope > details > summary');
    return normalize(trigger?.textContent);
  }

  function mobileMarkup() {
    return ITEMS.map((item, index) => `
      <li class="sq-shop-moment-menu__mobile-link-item" style="--sq-moment-index:${index + 1}">
        <a class="menu-drawer__menu-item menu-drawer__menu-item--child focus-inset sq-shop-moment-menu__mobile-link" href="${item.url}">
          <span>
            <strong>${item.title}</strong>
            <small>${item.note}</small>
          </span>
          <span aria-hidden="true">↗</span>
        </a>
      </li>
    `).join('');
  }

  function buildMobile(header) {
    const rootList = rootMobileList(header);
    if (!rootList || rootList.querySelector('[data-sq-shop-moment-menu-mobile]')) return false;

    const item = document.createElement('li');
    item.className = 'menu-drawer__list-item sq-shop-moment-menu__mobile';
    item.dataset.sqShopMomentMenuMobile = '';
    item.innerHTML = `
      <details class="sq-shop-moment-menu__details">
        <summary class="menu-drawer__menu-item menu-drawer__menu-item--mainlist focus-inset sq-shop-moment-menu__summary">
          <span class="menu-drawer__menu-item-text wrap-text">Shop by Moment</span>
          <span class="sq-shop-moment-menu__plus" aria-hidden="true"></span>
        </summary>
        <div class="sq-shop-moment-menu__mobile-panel">
          <p>Choose the occasion, then enter the matching wardrobe.</p>
          <ul class="menu-drawer__menu menu-drawer__menu--childlist list-unstyled" role="list">
            ${mobileMarkup()}
          </ul>
        </div>
      </details>
    `;

    const children = Array.from(rootList.children).filter((node) => node.matches?.('li'));
    const shop = children.find((node) => ['shop', 'shop home', 'shop every style'].includes(directMobileLabel(node)));
    const home = children.find((node) => directMobileLabel(node) === 'home');
    if (shop) shop.after(item);
    else if (home) home.after(item);
    else rootList.prepend(item);
    return true;
  }

  function apply() {
    const header = document.querySelector('#header-component');
    if (!header) return;
    buildDesktop(header);
    buildMobile(header);
  }

  function boot() {
    apply();
    const headerGroup = document.querySelector('#header-group') || document.documentElement;
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        apply();
      });
    });
    observer.observe(headerGroup, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', apply);
})();